module.exports = "/_next/static/chunks/images/meaningful-ageing-logo-c1e7c436db298da7379a398fef08b0f5.svg";